<template>
  <div class="col-md-12 grid-margin stretch-card">
    <div class="card">
      <div class="card-body" v-if="isLogged">
        <div class="row">
          <div class="col-md-6">
            <h3 class="font-weight-bold">
              Gestión de Bloqueos
            </h3>
          </div>
        </div>
        <br />
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th></th>
                <th>Cliente</th>
                <th>Fecha bloqueo</th>
                <th>Usuario bloqueo</th>
              </tr>
            </thead>
            <tbody>
              <td></td>
              <tr v-for="item in bloqueos" :key="item.id">
                <td></td>
                <td>{{ item.codigoCliente }}</td>
                <td>{{ item.fechaBloqueo }}</td>
                <td>{{ item.usuarioBloqueo }}</td>
              </tr>
            </tbody>
          </table>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "GestionBloqueos",
  data() {
    return {
      mensaje: "",
    };
  },
  created() {
    if (!this.$store.getters["auth/isLogged"]) {
      this.$store.dispatch("auth/logout");
      return false;
    }
  },
  mounted() {
    this.consultarBaseObjetivos();
  },
  methods: {
    loaderSpinner() {
      this.loader = this.$loading.show();
    },
    async consultarBaseObjetivos() {
      this.loaderSpinner();
      try {
        await this.$store.dispatch("cartera/consultarBloqueos");
      } catch (error) {
        alert("No se pudo realizar la consulta");
      } finally {
        this.loader.hide();
      }
    },
  },
  computed: {
    isLogged() {
      return this.$store.getters["auth/isLogged"]
        ? this.$store.getters["auth/isLogged"]
        : false;
    },
    bloqueos() {
      return this.$store.getters["cartera/bloqueos"]
        ? this.$store.getters["cartera/bloqueos"]
        : [];
    }
  }
};
</script>
<style>
.no-padding {
  padding: 0;
  margin: 0;
}

.radio-margin {
  margin-right: 15px;
}
</style>
